import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import ModalAddProduct from './modal/productmodal.vue'
import ActionButtonProduct from './components/ActionButtonProduct.vue'
import ParcelasDetalhadas from './components/ParcelasDetalhadas.vue'

import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'
import productSituation from '@/enums/enumProductSituation.js'
import cardSituation from '@/enums/enumCardSituation.js'
import boardTypes from '@/enums/enumBoardTypes.js'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import EnumBoardTypes from '../../../../../enums/enumBoardTypes'

export default {
  name: 'CrmDetailsProduct',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    cardActive: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      data: null,
      form: null,
      products: null,
      hasProducts: false,
      productSituation: productSituation,
      cardSituation: cardSituation,
      boardTypes: boardTypes,
      showNewPreview: false,
      showParcelasDetalhadas: false,
      columnsBase: [
        this.$lang.Common.DataTable.ProductTable.Date,
        this.$lang.Common.DataTable.ProductTable.Product,
        this.$lang.Common.DataTable.ProductTable.Value,
        this.$lang.Common.DataTable.ProductTable.Observation,
        this.$lang.Common.DataTable.ProductTable.Actions
      ],
      columnsVenda: [
        this.$lang.Common.DataTable.ProductTable.Date,
        this.$lang.Common.DataTable.ProductTable.Product,
        this.$lang.Common.DataTable.ProductTable.Value,
        this.$lang.Common.DataTable.ProductTable.Installments,
        this.$lang.Common.DataTable.ProductTable.Unit,
        this.$lang.Common.DataTable.ProductTable.Observation,
        this.$lang.Common.DataTable.ProductTable.Actions
      ]
    }
  },
  components: {
    ModalAddProduct, ActionButtonProduct, toogleswitch, ParcelasDetalhadas
  },
  computed: {
    EnumBoardTypes () {
      return EnumBoardTypes
    },
    totalValue () {
      let result = null
      if (this.objList && this.objList.length > 0) {
        this.objList.forEach(element => {
          result += element.valor
        })
      }
      return result
    },
    totalUnit () {
      let result = null
      if (this.objList && this.objList.length > 0) {
        this.objList.forEach(element => {
          result += element.quantidade
        })
      }
      return result
    },
    cardIsActive () {
      if ((this.card.situacao === this.cardSituation.ATIVO) &&
        (this.card.boardColumn.board.arquivado === false) &&
        (this.card.boardColumn.board.isReadOnly === false)) { return true }
      return false
    }
  },
  watch: {
    card () {
      if (this.card) {
        this.onLoadAllProducts()
      }
    },
    showNewPreview () {
      this.onReload()
    },
    showParcelasDetalhadas () {
      this.onReload()
    }
  },
  methods: {
    onLoad () {
      this.onLoadAllProducts()
    },
    onLoadAllProducts () {
      if (!this.card) {
        console.warn('Nenhum card selecionado.')
        return
      }

      this.isLoading = true

      let request = null

      // Garantir valores padrão se tableGrid não existir (quando em visualização detalhada)
      const pagingLimit = (this.$refs.tableGrid && this.$refs.tableGrid.pagingLimit) ? this.$refs.tableGrid.pagingLimit : 10
      const pagingIndex = (this.$refs.tableGrid && this.$refs.tableGrid.pagingIndex) ? this.$refs.tableGrid.pagingIndex : 0

      if (this.boardTypes.COBRANCA === this.card.boardColumn.board.tipoBoard) {
        request = CardProductRepository.SearchBySituacao(this.card.id, productSituation.ATIVO, pagingLimit, pagingIndex)
      } else {
        request = CardProductRepository.Search(this.card.id, pagingLimit, pagingIndex)
      }

      request
        .then((response) => {
          if (response.data.content) {
            this.hasProducts = response.data.content.length > 0
            this.onResultGrid(response)
          } else {
            console.warn('Resposta inesperada da API:', response)
            this.hasProducts = false
          }
        })
        .catch((error) => {
          console.error('Erro ao carregar produtos:', error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onAddProduct () {
      this.$refs.ModalAddProduct.showModal()
    },
    onReload () {
      this.$emit('Reload')
      this.onLoadAllProducts()
    },
    onReceiveReload () {
      this.onReload()
    },
    destroyModal () {
      this.$refs['ModalAddProduct'].hideModal()
    },
    onDelete (obj) {
      CardProductRepository.Delete(obj.id)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(
              this.card.pessoa.document,
              'sys_produto_excluido',
              'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi excluído!',
              this.ip, this.latitude, this.longitude, this.card.id
            )
            this.onReload()
          } else {
            console.warn('Resposta inesperada:', response)
          }
        })
        .catch((error) => {
          console.error('Erro ao excluir produto:', error)
          this.onException(error)
        })
    },
    onEdit (obj) {
      if (this.isProductGanhoOrPerdido(obj)) {
        return
      }
      if (!this.boardArchived) this.$refs.ModalAddProduct.showModal(obj)
    },
    isProductGanhoOrPerdido (obj) {
      return obj.situacao === this.productSituation.GANHO ||
             obj.situacao === this.productSituation.PERDIDO
    },
    getProductTabClass (obj) {
      if (!obj || !obj.situacao) {
        return ''
      }
      if (obj.situacao === this.productSituation.GANHO) {
        return 'product-tab-ganho'
      } else if (obj.situacao === this.productSituation.PERDIDO) {
        return 'product-tab-perdido'
      }
      return ''
    },
    getProductCardBorderClass (obj) {
      if (!obj || !obj.situacao) {
        return ''
      }
      if (obj.situacao === this.productSituation.GANHO) {
        return 'product-card-ganho'
      } else if (obj.situacao === this.productSituation.PERDIDO) {
        return 'product-card-perdido'
      }
      return ''
    },
    formatValue (value) {
      return Tools.formatMoneyBR(value)
    },
    formatDate (d, hasTime) {
      const date = new Date(d)
      date.setHours(date.getHours() + 3)

      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month}/${year}` + (hasTime ? ` às ${hours}:${minutes}` : '')
    },
    checkTypeBoard (card, tipo) {
      if (card && card.boardColumn.board.tipoBoard === tipo) {
        return true
      }
      return false
    },
    checkGainPerProduct (card) {
      return card.boardColumn.board.ganhoPorProduto
    },
    textColorProduct (obj) {
      const { boardColumn } = this.card
      const boardType = boardColumn.board.tipoBoard

      const boardVenda = boardType === this.boardTypes.VENDA
      const boardCobranca = boardType === this.boardTypes.COBRANCA
      const isGanhoOrLiquidado = [productSituation.GANHO, productSituation.LIQUIDADO].includes(obj.situacao)

      if ((boardVenda || boardCobranca) && isGanhoOrLiquidado) {
        return 'text-success text-center'
      }

      if (boardVenda && obj.situacao === productSituation.PERDIDO) {
        return 'text-danger text-center'
      }

      return 'text-center'
    },
    actionProduct (obj, actionToPerform) {
      switch (actionToPerform) {
        case productSituation.ATIVO:
          this.resetProduct(obj)
          break
        case productSituation.GANHO:
          this.winProduct(obj)
          break
        case productSituation.PERDIDO:
          this.loseProduct(obj)
          break
        case 'DELETAR':
          this.deleteProduct(obj)
          break
        default:
          console.error('Opção inválida!')
          break
      }
    },
    async resetProduct (obj) {
      obj.situacao = productSituation.ATIVO

      try {
        const response = await CardProductRepository.ChangeStatus(obj.id, obj)
        if (response.status === 200) {
          await createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_reativado', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi resetado!', this.ip, this.latitude, this.longitude, this.card.id)
          this.$nextTick(() => {
            this.onReload()
          })
        }
      } catch (e) {
        this.onException(e)
      }
    },
    async winProduct (obj) {
      obj.situacao = productSituation.GANHO

      try {
        const response = await CardProductRepository.ChangeStatus(obj.id, obj)
        if (response.status === 200) {
          await createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_ganho', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi ganho!', this.ip, this.latitude, this.longitude, this.card.id)
          this.$nextTick(() => {
            this.onReload()
          })
        }
      } catch (e) {
        this.onException(e)
      }
    },
    async loseProduct (obj) {
      obj.situacao = productSituation.PERDIDO

      try {
        const response = await CardProductRepository.ChangeStatus(obj.id, obj)
        if (response.status === 200) {
          await createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_perdido', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi perdido!', this.ip, this.latitude, this.longitude, this.card.id)
          this.$nextTick(() => {
            this.onReload()
          })
        }
      } catch (e) {
        this.onException(e)
      }
    },
    async deleteProduct (obj) {
      try {
        const response = await CardProductRepository.Delete(obj.id)
        if (response.status === 200) {
          await createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_excluido', 'O Produto ' + obj.produtoDTO.nome + ' no valor de R$ ' + this.formatValue(obj.valor) + ' foi excluído!', this.ip, this.latitude, this.longitude, this.card.id)
          this.$nextTick(() => {
            this.onReload()
          })
        }
      } catch (e) {
        this.onException(e)
      }
    },
    valueInstallments (obj) {
      if (obj.qtdParcelas > 1) {
        return obj.qtdParcelas ? `${obj.qtdParcelas}x ${this.formatValue(obj.valorParcelas ? obj.valorParcelas : '-')}` : '-'
      } else if (obj.qtdParcelas === 1) {
        return obj.qtdParcelas ? `À Vista ${this.formatValue(obj.valorParcelas ? obj.valorParcelas : '-')}` : '-'
      } else {
        return '-'
      }
    },
    onPromessaCriada () {
      // Recarregar produtos quando promessa for criada
      this.onReload()
    },
    recarregarParcelasDetalhadas () {
      // Método público para recarregar grade analítica de parcelas
      if (this.$refs.parcelasDetalhadas) {
        this.$refs.parcelasDetalhadas.recarregarParcelas()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/product/product.js